export type CityState = {
  id: string;
  uf: string;
  city: string;
};

export enum Gender {
  MALE = 'MALE',
  FEMALE = 'FEMALE',
  NONBINARY = 'NONBINARY',
  NOT_INFORMED = 'NOT_INFORMED',
}

export enum DocumentType {
  CPF = 'CPF',
  CNPJ = 'CNPJ',
}

export type TermVersion = {
  version: number;
  type: 'online';
};

export type BasicAuthenticatedUser = {
  userId: string;
  fullName: string;
  documentType: DocumentType;
  documentNumber: string;
  email: string;
  termVersions: TermVersion[];
  isCollaborator: boolean;
};

export type Contact = {
  email: string;
  phones: string[];
};

export type CustomerAddress = {
  addressLine1: string;
  addressLine2: string;
  city: string;
  id?: string;
  neighborhood: string;
  number: string;
  state: string;
  zipcode?: string;
};

export type Dependent = {
  birthday: string;
  contact: Contact;
  documentNumber: string;
  documentType: DocumentType;
  gender: Gender;
  id: string;
  legalName: string;
  socialName: string;
};

export type Dependents = Dependent[];

export type AuthenticatedUser = {
  address?: CustomerAddress;
  birthday: string;
  contact?: Contact;
  createdAt?: string;
  dependents?: Dependents;
  documentNumber: string;
  documentType?: DocumentType;
  gender?: Gender;
  id?: string;
  legalName: string;
  socialName: string;
  termVersion?: TermVersion;
  updatedAt?: string;
  phoneUpdatedAt?: string | null;
};

export type Token = string;

export type LoginData = {
  username: string;
  password: string;
};

export type UpdateCustomerRequestBody = {
  documentType: DocumentType;
  documentNumber: string;
  legalName: string;
  socialName?: string;
  contact: Contact;
  birthday: string;
  gender: string;
  password?: string;
};

export type UpdateCustomerAddressRequestBody = {
  customerAddress: Partial<CustomerAddress>;
};
